import { useNoticesStore } from "./notices";
import { usePopupsStore } from "./popups";

export const resetAllStores = () => {
	return [useNoticesStore, usePopupsStore].forEach(
		(store) => store.getState && store.getState().reset()
	);
};
